module.exports = __webpack_public_path__ + "static/img/10.4f8b600.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/eng/10.png
// module id = paYH
// module chunks = 0